<template>
  <div class="content-center none-click">
    <div v-if="bannerList && bannerList.length" class="banner">
      <a-carousel autoplay>
        <div
          v-for="item in bannerList"
          :key="item.adNo"
          @click="goPath(item.linkAddress)"
        >
          <img :src="item.adPicUrl" class="banner-img" />
        </div>
      </a-carousel>
    </div>
    <div class="content">
      <div class="solution">
        <div class="title">数智化赋能传统零售门店及企业客户转型升级</div>
        <div class="desc">
          提供全场景、全方位、全流程的数智化综合服务解决方案
        </div>
        <div class="menu menu_bg1">
          <div class="menu_title">千橙零售云</div>
          <div class="menu_text">零售门店数智化升级，助力经营增收提效</div>
          <div class="menu_box">
            <div class="box_item" @click="linkTo('QcErpSystem')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box1.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙ERP系统</div>
                <div class="right_text">到店/到家交易业务管理</div>
              </div>
            </div>
            <div class="box_item" @click="linkTo('QcCashier')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box2.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙收银系统</div>
                <div class="right_text">半自动/自助一体机收单</div>
              </div>
            </div>
            <div class="box_item" @click="linkTo('QcChain')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box3.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙连锁系统</div>
                <div class="right_text">支持直营/联营/加盟多业态</div>
              </div>
            </div>
            <div class="box_item" @click="linkTo('QcShopkeeper')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box4.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙新零售系统</div>
                <div class="right_text">门店O2O一体化综合管理</div>
              </div>
            </div>
            <div class="box_item" @click="linkTo('QcAssociation')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box5.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">汇团团社群营销系统</div>
                <div class="right_text">社群团购分享小程序系统</div>
              </div>
            </div>
            <div class="box_item" @click="linkTo('QcShoppingMall')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box6.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙微商城系统</div>
                <div class="right_text">社群电商小程序系统</div>
              </div>
            </div>
            <div class="box_item" @click="linkTo('QcMarketing')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box7.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙会员营销系统</div>
                <div class="right_text">基于会员的SCRM系统</div>
              </div>
            </div>
          </div>
        </div>
        <div class="menu menu_bg2">
          <div class="menu_title">千橙电商云</div>
          <div class="menu_text">全链路电商能力覆盖，支持多种电商模式落地</div>
          <div class="menu_box">
            <div class="box_item" @click="linkTo('QcCommerce')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box8.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙电商S2B2C系统</div>
                <div class="right_text">全链路全闭环交易系统</div>
              </div>
            </div>
            <div class="box_item" @click="linkTo('QcB2BChannel')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box9.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙电商B2b分销系统</div>
                <div class="right_text">批发渠道多层级分销系统</div>
              </div>
            </div>
            <div class="box_item" @click="linkTo('QcLiveBroadcast')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box10.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">汇好看直播系统</div>
                <div class="right_text">视频号+小程序直播系统</div>
              </div>
            </div>
          </div>
        </div>
        <div class="menu menu_bg3">
          <div class="menu_title">千橙服务云</div>
          <div class="menu_text">AI+新场景，提升运营服务效率</div>
          <div class="menu_box1">
            <div class="box_item" @click="linkTo('QcTool')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box11.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙RPA工具箱</div>
                <div class="right_text">机器人流程自动化服务</div>
              </div>
            </div>
            <div
              class="box_item"
              style="margin-left: 10px"
              @click="linkTo('QcDigit')"
            >
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box12.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙数字人</div>
                <div class="right_text">AI数字人直播助手</div>
              </div>
            </div>
          </div>
        </div>
        <div class="menu menu_bg4">
          <div class="menu_title">千橙分销云</div>
          <div class="menu_text">
            打造“连接” +“提效”+“交易”的一站式智能分销平台
          </div>
          <div class="menu_box">
            <div class="box_item" @click="linkTo('QcDistribution')">
              <div class="item_left">
                <img src="@/assets/Mobile/images/home/box13.png" alt="" />
              </div>
              <div class="item_right">
                <div class="right_title">千橙分销</div>
                <div class="right_text">基于企微的业务员分销系统</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="scene">
        <div class="title">专注八大行业 聚焦四大业务领域</div>
        <div class="sub-title">辅以两大基础服务能力 两端闭环服务</div>
        <div class="content">
          <img src="@/assets/Mobile/images/home/home_scene.png" alt="" />
        </div>
      </div>
      <div class="technical-team">
        <div class="sk-mobile-title">
          <div class="title">强大的技术研发团队 保障系统安全稳定</div>
          <div class="sub-title">
            技术创新有保障 120+项软件著作权 20+科研成果 持续升级
          </div>
        </div>
        <div class="content">
          <div class="item">
            <div class="percent">99.99<span class="unit">%</span></div>
            <div class="line" />
            <div class="advantage">系统安全稳定</div>
          </div>
          <div class="item">
            <div class="percent">3000<span class="unit">笔</span></div>
            <div class="line" />
            <div class="advantage">每秒处理订单笔数</div>
          </div>
          <div class="item">
            <div class="percent">300<span class="unit">毫秒</span></div>
            <div class="line" />
            <div class="advantage">服务器平均响应速度</div>
          </div>
          <div class="item">
            <div class="percent">98<span class="unit">%</span></div>
            <div class="line" />
            <div class="advantage">客户满意度高达</div>
          </div>
          <div class="item">
            <div class="percent">200+<span class="unit">人</span></div>
            <div class="line" />
            <div class="advantage">技术团队保驾护航</div>
          </div>
        </div>
      </div>
      <div class="network-system">
        <div class="title">汇通数科SaaS全国服务网络系统</div>
        <div class="statistics">
          <img src="@/assets/Mobile/images/home/home_reason.png" alt="" />
        </div>
        <div class="content">
          <img src="@/assets/Mobile/images/home/home_map.png" alt="" />
        </div>
      </div>
      <!-- <div class="brand">
        <div class="title">合作品牌商</div>
        <div class="content">
          <img src="@/assets/Mobile/images/home/home_brand.png" alt="">
        </div>
      </div> -->
      <div class="auth">
        <div class="title">权威认证 实力认可</div>
        <div class="content">
          <div class="item">
            <img src="@/assets/Mobile/images/home/home_auth1.png" alt="" />
            <span>双软认证</span>
          </div>
          <div class="item">
            <img src="@/assets/Mobile/images/home/home_auth2.png" alt="" />
            <span>高新技术企业</span>
          </div>
          <div class="item">
            <img src="@/assets/Mobile/images/home/home_auth3.png" alt="" />
            <span>企业信用等级<br />证书（AAA)</span>
          </div>
          <div class="item">
            <img src="@/assets/Mobile/images/home/home_auth4.png" alt="" />
            <span>网络安全等级<br />保护2.0(三级)</span>
          </div>
          <div class="item">
            <img src="@/assets/Mobile/images/home/home_auth5.png" alt="" />
            <span>质量管理体系认证</span>
          </div>
        </div>
      </div>
      <ContactForm />
    </div>
  </div>
</template>

<script>
import metaInfo from "@/common/util/metaInfo";
import ContactForm from "@/Mobile/Mobilecom/ContactForm";
import { getAdvertiseList, browseCount } from "@/apis/index";

export default {
  metaInfo: metaInfo.Index,
  components: {
    ContactForm,
  },
  data() {
    return {
      bannerList: [],
    };
  },
  mounted() {
    this.getBannerList();
  },
  methods: {
    goPath(item) {
      console.log(item, "itemitem");
      if (item) {
        window.open(item);
      }
    },
    linkTo(path) {
      this.$router.push({ path: "/m/" + path });
      this.$nextTick(() => {
        this.open = false;
      });
    },
    getBannerList() {
      // 1：订阅，2：工作台，3:首页，4:PC官网首页，5:h5官网首页
      var params = { releaseSystemLocation: 5 };
      getAdvertiseList(params)
        .then((res) => {
          this.bannerList = res;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.content-center {
  width: 375px;
  margin-top: 50px;

  .banner {
    width: 100%;
    height: 200px;
    position: relative;
    //   background: url('~@/assets/Mobile/images/home/banner.png')no-repeat center;
    //   background-size: 375px 200px;
    .banner-img {
      width: 100%;
      height: 200px;
      z-index: 1000;
    }
    //   .banner_box{
    //     width: 160px;
    //     position: absolute;
    //     left: 15px;
    //     top: 78px;
    //     .banner_title{
    //         width: 160px;
    //         height: 22px;
    //         font-size: 16px;
    //         font-family: PingFangSC, PingFang SC;
    //         font-weight: 500;
    //         color: #FFFFFF;
    //         line-height: 22px;
    //     }
    //     .banner_text{
    //         width: 151px;
    //         font-size: 10px;
    //         font-family: PingFangSC, PingFang SC;
    //         font-weight: 400;
    //         color: #FFFFFF;
    //         line-height: 17px;
    //         margin-top:6px;
    //         text-align: left;
    //     }
    //   }
  }
  .content {
    background: #fafafa;
    .solution {
      padding: 30px 15px 0;
      .title {
        font-size: 20px;
        font-weight: 600;
        color: #595961;
        line-height: 28px;
      }
      .desc {
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #8b8fa1;
        line-height: 20px;
        text-align: center;
      }
      .menu_bg1 {
        background: url("~@/assets/Mobile/images/home/menu1.png") no-repeat
          center;
        background-size: 100% 100%;
      }
      .menu_bg2 {
        background: url("~@/assets/Mobile/images/home/menu2.png") no-repeat
          center;
        background-size: 100% 100%;
      }
      .menu_bg3 {
        background: url("~@/assets/Mobile/images/home/menu3.png") no-repeat
          center;
        background-size: 100% 100%;
      }
      .menu_bg4 {
        background: url("~@/assets/Mobile/images/home/menu4.png") no-repeat
          center;
        background-size: 100% 100%;
      }
      .menu {
        width: 100%;
        position: relative;
        margin-top: 12px;
        padding: 14px 14px;
        .menu_title {
          height: 17px;
          font-size: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 17px;
          text-align: left;
        }
        .menu_text {
          height: 14px;
          font-size: 7px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 10px;
          margin-top: 4px;
          text-align: left;
        }
        .menu_box1 {
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          .box_item {
            width: 100px;
            height: 29px;
            background: #ffffff;
            border-radius: 2px;
            display: flex;
            flex-direction: row;
            padding: 5px 5px;
            margin-bottom: 9px;
            .item_left {
              width: 12px;
              img {
                width: 12px;
                height: 11px;
              }
            }
            .item_right {
              text-align: left;
              margin-left: 2px;
              .right_title {
                height: 10px;
                font-size: 7px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 10px;
              }
              .right_text {
                height: 8px;
                font-size: 5px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 8px;
              }
            }
          }
        }
        .menu_box {
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          .box_item {
            width: 100px;
            height: 29px;
            background: #ffffff;
            border-radius: 2px;
            display: flex;
            flex-direction: row;
            padding: 5px 5px;
            margin-bottom: 9px;
            .item_left {
              width: 12px;
              img {
                width: 12px;
                height: 11px;
              }
            }
            .item_right {
              text-align: left;
              margin-left: 2px;
              .right_title {
                height: 10px;
                font-size: 7px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 10px;
              }
              .right_text {
                height: 8px;
                font-size: 5px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 8px;
              }
            }
          }
        }
      }
    }
    .scene {
      background: #fff;
      padding: 30px 15px 19px 13px;
      margin: 15px auto 0;
      .content {
        background: #fff;
      }
      .title {
        font-size: 20px;
        font-weight: 600;
        color: #595961;
        line-height: 28px;
      }
      .sub-title {
        color: #8b8fa1;
        line-height: 20px;
        margin-top: 8px;
      }
      .content {
        height: 197px;
        width: 346px;
        margin-top: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .network-system {
      background: #fafafa;
      padding: 30px 16px 0 15px;
      .title {
        font-size: 20px;
        font-weight: 600;
        color: #595961;
        line-height: 28px;
      }
      .statistics {
        width: 344px;
        height: 52px;
        margin: 25px auto 9px;
        img {
          width: 344px;
        }
      }
      .content {
        width: 330px;
        height: 291px;
        margin: 0 auto;
        img {
          width: 330px;
        }
      }
    }
    .brand {
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #595961;
        line-height: 25px;
        margin: 0 auto;
      }
      .content {
        width: 355px;
        margin: 15px auto 25px;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
    .technical-team {
      height: 310px;
      background: url("~@/assets/Mobile/images/home/home_technical-team.png")
        no-repeat center;
      background-size: 100%;
      .sk-mobile-title {
        z-index: 100;
        .title {
          color: #fff;
        }
        .sub-title {
          color: #bdbdbd;
        }
      }
      .content {
        width: 339px;
        display: flex;
        align-content: space-between;
        flex-flow: row wrap;
        background: transparent;
        margin: 24px auto 0;
        .item {
          width: 113px;
          height: 75px;
          margin-bottom: 20px;
          text-align: left;
          .percent {
            font-size: 28px;
            font-weight: 600;
            color: #ffffff;
            line-height: 38px;
            .unit {
              font-size: 10px;
              font-weight: 400;
              color: #ffffff;
              line-height: 13px;
              padding-left: 5px;
            }
          }
          .line {
            width: 41px;
            height: 5px;
            background: #3986ff;
            margin-top: 8px;
          }
          .advantage {
            font-size: 10px;
            font-weight: 400;
            color: #bdbdbd;
            line-height: 13px;
            margin-top: 11px;
          }
        }
      }
    }
    .auth {
      background: #fff;
      padding: 30px 17px 20px;
      .title {
        font-size: 20px;
        font-weight: 600;
        color: #595961;
        line-height: 28px;
      }
      .content {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
        background: #fff;
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            display: block;
            width: 65px;
            height: 57px;
          }
          span {
            height: 16px;
            font-size: 6px;
            font-weight: 400;
            color: #595961;
            line-height: 10px;
          }
        }
      }
    }
  }
}
</style>
